import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/core/auth.service';
import { SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ERROR_PASSWORD_MISMATCH_CODE } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-auth-forgot-pss-confirm-dialog',
  templateUrl: './auth-forgot-pss-confirm-dialog.component.html',
  styleUrls: ['./auth-forgot-pss-confirm-dialog.component.scss'],
})
export class AuthForgotPssConfirmDialogComponent implements OnInit, AfterViewInit {
  @ViewChildren('otp') otp?: QueryList<ElementRef>;
  seller_email: string;
  pss_reset_confirm_from_group: FormGroup = this.form_service.auth_pss_reset_confirm_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_password_visible: boolean = false;
  is_forgot_pss_confirm_running: boolean = false;
  active_input_index: number = 0;

  constructor(
    private form_service: FormService,
    private auth_service: AuthService,
    private utils_service: UtilsService,
    private dialog_ref: MatDialogRef<AuthForgotPssConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.seller_email = data.username;
  }

  ngOnInit(): void {
    this.pss_reset_confirm_from_group.reset();
    this.utils_service.setActiveInput(0, this.pss_reset_confirm_from_group);
  }

  ngAfterViewInit(): void {
    if (this.otp && this.otp.first) {
      this.otp.first.nativeElement.focus();
    }
  }

  onMoveToNext(event: any, current_index: number): void {
    const response = this.utils_service.moveToNext(event, current_index, this.pss_reset_confirm_from_group, this.otp);
    if (response) {
      return;
    }
  }

  onMoveToPrev(event: KeyboardEvent, index: number): void {
    const response = this.utils_service.moveToPrev(event, index, this.pss_reset_confirm_from_group, this.otp);
    if (response) {
      return;
    }
  }

  onPasteOtp(event: ClipboardEvent, current_index: number): void {
    const response = this.utils_service.pasteOtp(event, current_index, this.pss_reset_confirm_from_group, this.otp);
    if (response) {
      return;
    }
  }

  getFormGroupControls(): number[] {
    return this.utils_service.getFormGroupControls();
  }

  onSetActiveInput(index: number): void {
    this.active_input_index = this.utils_service.setActiveInput(index, this.pss_reset_confirm_from_group);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onPssResetClick(): void {
    if (this.isFormValid()) {
      const otp: string = this.utils_service.getOtpValue(this.pss_reset_confirm_from_group);
      const password: string = this.pss_reset_confirm_from_group.get(this.form_service.password_label)?.value;
      const password_confirm: string = this.pss_reset_confirm_from_group.get(
        this.form_service.password_confirm_label,
      )?.value;
      if (password === password_confirm) {
        this.confirmForgotPassword(this.seller_email, otp, password);
      } else {
        const processed_error: SplittypayError = {
          code: ERROR_PASSWORD_MISMATCH_CODE,
          message: '',
        };
        this.dialog_ref.close({ error: processed_error });
      }
    }
  }

  confirmForgotPassword(username: string, otp: string, password: string): void {
    this.is_forgot_pss_confirm_running = true;
    this.auth_service.forgotPasswordSubmit(username, otp, password).subscribe({
      next: response => {
        this.dialog_ref.close({ success: true });
        this.is_forgot_pss_confirm_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = {
          code: error.code,
          message: error.message,
        };
        this.dialog_ref.close({ error: processed_error });
        this.is_forgot_pss_confirm_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.pss_reset_confirm_from_group);
  }

  hasPssLengthError(confirm: boolean): boolean | undefined {
    return this.utils_service.hasPssLengthError(
      this.pss_reset_confirm_from_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }

  hasPssPatternError(confirm: boolean): boolean | undefined {
    return this.utils_service.hasPssPatternError(
      this.pss_reset_confirm_from_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }

  getPssFormFieldErrorClass(confirm: boolean): {
    [key: string]: boolean | undefined;
  } {
    return this.utils_service.getPssFormFieldErrorClass(
      this.pss_reset_confirm_from_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }
}
